<template>
  <div class="SplashScreen">
    <div class="SplashScreen__content">
      <img
        src="../assets/images/splash.png"
        alt="Un singe avec un chapeau de marin tenant une bouteille de vin avec une référence à Walt Whitman…"
      />
    </div>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss" scoped>
  .SplashScreen {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
  }
</style>
